<template>
  <v-container fluid class="mt-16 px-6">
    <div>
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Government Purchase Orders</h2>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="openAddModal" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Add Purchase Order
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- Purchase Order Table -->
          <customer-purchase-order-table
            ref="purchaseOrderTable"
            @notification="handleNotification"
          />
        </v-card-text>
      </v-card>
    </div>

    <!-- Add Purchase Order Modal -->
    <add-customer-purchase-order-modal
      ref="addModal"
      @success="handleSuccess"
      @error="handleError"
    />

    <!-- Notification Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AddCustomerPurchaseOrderModal from "../components/CustomerPurchaseOrder/addCustomerPurchaseOrder.vue";
import CustomerPurchaseOrderTable from "../components/CustomerPurchaseOrder/customerPurchaseOrderTable.vue";

export default {
  name: "PurchaseOrder",

  components: {
    AddCustomerPurchaseOrderModal,
    CustomerPurchaseOrderTable,
  },

  data() {
    return {
      refreshing: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      default_server_url: "auth/default_server_url",
    }),
  },

  methods: {
    openAddModal() {
      this.$refs.addModal.open();
    },

    handleNotification(message, type) {
      const colorMap = {
        success: "success",
        error: "error",
        info: "info",
        warning: "warning",
      };

      this.snackbar = {
        show: true,
        message: message,
        color: colorMap[type] || "info",
        timeout: type === "error" ? 5000 : 3000,
      };
    },

    handleSuccess(message) {
      this.handleNotification(message, "success");
      // Refresh the table after successful creation
      if (this.$refs.purchaseOrderTable) {
        this.$refs.purchaseOrderTable.refreshTable();
      }
    },

    handleError(message) {
      this.handleNotification(message, "error");
    },

    async refreshData() {
      this.refreshing = true;
      try {
        if (this.$refs.purchaseOrderTable) {
          await this.$refs.purchaseOrderTable.refreshTable();
        }
      } catch (error) {
        this.handleNotification("Failed to refresh data", "error");
      } finally {
        this.refreshing = false;
      }
    },
  },

  mounted() {
    // Any initialization logic can go here
  },
};
</script>

<style scoped></style>
